<template>
  <button @click="$emit('click', $event)" v-bind="$attrs">
    <font-awesome-icon
      v-if="direction === 'prev'"
      :icon="['fas', 'chevron-left']"
      class="icon"
      size="lg"
    />
    <font-awesome-icon
      v-else-if="direction === 'next'"
      :icon="['fas', 'chevron-right']"
      size="lg"
    />
  </button>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/pro-solid-svg-icons";

library.add(faChevronLeft, faChevronRight);

export default {
  name: "TablePageButton",
  components: { FontAwesomeIcon },
  props: {
    direction: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../style_variables/_colors.scss";
button {
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  border-radius: 4px;
  height: 44px;
  width: 44px;
  color: $grey_abbey;
  background-color: $grey_alabaster;
  cursor: pointer;
  &:disabled {
    color: $grey_manatee;
    background-color: $grey_bg;
    cursor: inherit;
  }
}
</style>
